export var errorCodeMap = {
    1000: 'SitecheckJwtCheckFailed',
    1001: 'SitecheckHaveWantNotEqual',
    1002: 'SitecheckOriginDifferent',
    1003: 'SitecheckHostContainDomain',
    1004: 'UsercheckNotLoggedIn',
    1005: 'UsercheckNotLoggedOut',
    2000: 'WrongDataFormat',
    2001: 'SessionVerifyTypeNotFound',
    2002: 'SessionVerifyExpireNotFound',
    2003: 'SessionVerifyTokenNotFound',
    2004: 'VerifyTokenExpired',
    2005: 'WrongVerifyToken',
    2006: 'StrategyNotFound',
    4000: 'UsernameIsAlrealyUsed',
    4001: 'EmailIsAlrealyUsed',
    4002: 'PhoneIsAlrealyUsed',
    4003: 'SQLNoRows',
    4004: 'EmailNotFound',
    4005: 'PhoneNotFound',
    4006: 'SignalCantDelete',
    4007: 'SignalIsEnabled',
    4008: 'SignalIsDisabled',
    4009: 'SignalCantSubmit',
    4010: 'SignalIsNotCreated',
    4011: 'SignalIsNotPassed',
    4012: 'SignalEntryWrongInfo',
    4013: 'WsActionWrongFormat',
    4014: 'WsActionMethodIsNotExists',
    4015: 'WsActionAuthFailed',
    4016: 'WsActionChannelIsNotExists',
    4017: 'WsAuthed',
    4018: 'WsUnauth',
    4019: 'FollowInvestmentAmountTooHigh',
    4020: 'FollowInvestmentAmountTooLow',
    4021: 'SymbolAliasNotExists',
    4022: 'InsufficientUserWalletBalance',
    4023: 'RobotIsNotExists',
    4024: 'InsufficientRobotBalance',
    4025: 'SignalCantUpdate',
    4026: 'WrongFileFormat',
    4027: 'WrongFileSize',
    4028: 'FileUploadError',
    4029: 'FileDeleteError',
    4030: 'WrongVersion',
    4031: 'ReferrerNotFound',
    4032: 'MTCPInvalidAccount',
    4033: 'MTBrokerSearchVersionError',
    4034: 'MTBrokerSearchCompanyRequired',
    4035: 'MTBrokerNotExists',
    4036: 'MTBrokerAccessPointError',
    4037: 'MTAccountError',
    4038: 'MTAccountIsDiff',
    4039: 'MTAccountEAConnecting',
    4040: 'WrongCompetitionTime',
    4041: 'WrongCompetitionType',
    4042: 'WrongCompetitionNumberOfReward',
    4043: 'WrongCompetitionConditionNumberOfPromote',
    4044: 'WrongCompetitionInvestAmount',
    4045: 'WrongCompetitionIsSpecifySymbol',
    4046: 'WrongCompetitionDescription',
    4047: 'UserHasJoinedCompetition',
    4048: 'UserHasNotJoinedCompetition',
    4049: 'NotDuringTheCompetition',
    4050: 'MustEnableOneDayBeforeCompetitionStart',
    4051: 'MustDisableBeforeCompetitionStart',
    4052: 'WrongCompetitionStatus',
    4053: 'CompetitionHasBeenEnd',
    4054: 'CompetitionNotFound',
    4055: 'CompetitionHaveNotEnd',
    4056: 'ThereAreStillCompetitionRobotInAction',
    4057: 'EmailIsAlreadyBound',
    4058: 'PhoneIsAlreadyBound',
    4059: 'BankAccountIsNotExists',
    4060: 'WrongBankCode',
    4061: 'BankCodeTypeIsNotExists',
    4062: 'WrongCurrencyType',
    4063: 'NameAlreadyExists',
    4064: 'GoogleAuthVerifyFailed',
    4065: 'GoogleAuthIsEnabled',
    4066: 'GoogleAuthIsNotEnabled',
    4067: 'BankNameAlreadyExists',
    4068: 'CryptoNameAlreadyExists',
    4069: 'WrongFeeType',
    4070: 'UsercheckDeviceTokenHasBeenDeleted',
    4071: 'UsercheckNotDeviceToken',
    4072: 'NumberOutOfRange',
    4073: 'ContentSizeOutOfRange',
    4074: 'DepositOrderNotFound',
    4075: 'DepositOrderStatusWrong',
    4076: 'DepositOrderTypeWrong',
    4077: 'WithdrawOrderNotFound',
    4078: 'WithdrawOrderStatusWrong',
    4079: 'WithdrawOrderTypeWrong',
    4080: 'IdNotFound',
    4081: 'InvalidParameters',
    4082: 'UserBankAccountNotFound',
    4083: 'PostgresqlDuplicateKey',
    4084: 'CurrencyNotSupport',
    4085: 'GoogleReCaptchaAssessmentsFailed',
    4086: 'ThereAreRobotsFollowing',
    4087: 'SignalPerformanceNotYetCalculated',
    4088: 'UserNotFound',
    4089: 'UserKycNotPassed',
    4090: 'RobotProfitUnsettlementCantBeReduced',
    4091: 'ProfitShareUnsettleExists',
    4092: 'BrokerTrustFundsWaitingDeposit',
    4093: 'RobotInsufficientMargin',
    4102: 'ApiNumberLimitExceeded',
    4298: 'UrlSuffixAlreadyExists',
    5000: 'ContextSiteNotFound',
    5001: 'ContextBrokerIdNotFound',
    5002: 'ContextSessionPrefixNotFound',
    5003: 'SiteTypeIsNotExists',
    5004: 'ServiceError',
    5005: 'SQLError',
    5006: 'PhoneNumberParseFailed',
    5007: 'SiteTokenGenerateFailed',
    5008: 'SendMailFailed',
    5009: 'NotEnoughConditions',
    5010: 'ContextUserIdNotFound',
    5011: 'ServerSideStreamRecvError',
    5012: 'ServerSideStreamSendError',
    5013: 'ClientSideStreamRecvError',
    5014: 'ClientSideStreamSendError',
    5015: 'RedisOperatingError',
    5016: 'WebsocketKeyIsExistsInRedis',
    5017: 'RedisPubSubPayloadUnmarshalFailed',
    5018: 'RedisPublishFailed',
    5019: 'ServerSideStreamTypeUnexpected',
    5020: 'ClientSideStreamTypeUnexpected',
    5021: 'ContextDone',
    5022: 'TxBeginError',
    5023: 'NilOneOfType',
    5024: 'UnexpectedOneOfType',
    5025: 'SendSmsFailed',
    5026: 'NilPointer',
    5027: 'MTBrokerSearchServiceError',
    5028: 'UserNotFound',
    5029: 'GoogleAuthVerifyError',
    5030: 'SessionGoogleAuthSecretNotFound',
    5031: 'IP2LocationError',
    5032: 'RequestFaild',
    5033: 'Timeout',
    5034: 'InvalidRequest',
    5035: 'RequestRejected',
    5036: 'Rejected',
    5037: 'InvalidSignature',
    5038: 'InvalidToken',
    5039: 'InvalidCredentials',
    5040: 'PermissionDenied',
    5041: 'BadRequest',
    5042: 'GoogleReCaptchaAssessmentsRequestFailed',
    5043: 'GoogleReCaptchaAssessmentsResponseUnmarshalJsonFailed',
    5044: 'DecimalParseError',
    5045: 'SymbolRuleIsNotExists',
    5046: 'MarginCalculationTypeIsNotExists',
    5047: 'MarginCalculateFailed',
    5048: 'BrokerSymbolIsNotExists',
    5049: 'SwapRuleIsNotExists',
    5050: 'SwapCalculateFailed',
    5051: 'ProfitCalculateFailed',
    5052: 'BrokerConfigIsNotExists',
    5053: 'CurrencyConvertFailed',
    5054: 'FeeRuleIsNotExists',
    5055: 'FeeCalculeteFailed',
    5056: 'MarginInfoGetFailed',
    5057: 'BrokerGroupIsNotExists',
    5058: 'PositionIsNotExists',
    5059: 'PositionCloseWaitTimeout',
    5060: 'OrderWaitTimeout',
    5061: 'ProfitShareResettleError',
};
